import ScreenNames from "../constants/routeNames";

export interface OnboardingFlowStep {
  screenName: ScreenNames;
  nextScreen: ScreenNames | null;
  previousScreen: ScreenNames | null;
}

export type OnboardingFlowConfig = {
  [key in ScreenNames]?: OnboardingFlowStep;
};

export const SIMPLE_ONBOARDING_FLOW: OnboardingFlowConfig = {
  [ScreenNames.SimpleOnboarding_0_WelcomeVideo]: {
    screenName: ScreenNames.SimpleOnboarding_0_WelcomeVideo,
    nextScreen: ScreenNames.SimpleOnboarding_1_Motivation,
    previousScreen: null,
  },
  [ScreenNames.SimpleOnboarding_1_Motivation]: {
    screenName: ScreenNames.SimpleOnboarding_1_Motivation,
    nextScreen: ScreenNames.SimpleOnboarding_1b_HealthGoals,
    previousScreen: ScreenNames.SimpleOnboarding_0_WelcomeVideo,
  },
  [ScreenNames.SimpleOnboarding_1b_HealthGoals]: {
    screenName: ScreenNames.SimpleOnboarding_1b_HealthGoals,
    nextScreen: ScreenNames.SimpleOnboarding_2_CookingStyle,
    previousScreen: ScreenNames.SimpleOnboarding_1_Motivation,
  },
  [ScreenNames.SimpleOnboarding_2_CookingStyle]: {
    screenName: ScreenNames.SimpleOnboarding_2_CookingStyle,
    nextScreen: ScreenNames.SimpleOnboarding_3_Diet,
    previousScreen: ScreenNames.SimpleOnboarding_1b_HealthGoals,
  },
  [ScreenNames.SimpleOnboarding_3_Diet]: {
    screenName: ScreenNames.SimpleOnboarding_3_Diet,
    nextScreen: ScreenNames.SimpleOnboarding_3b_DietGoals,
    previousScreen: ScreenNames.SimpleOnboarding_2_CookingStyle,
  },
  [ScreenNames.SimpleOnboarding_3b_DietGoals]: {
    screenName: ScreenNames.SimpleOnboarding_3b_DietGoals,
    nextScreen: ScreenNames.SimpleOnboarding_4_Allergens,
    previousScreen: ScreenNames.SimpleOnboarding_3_Diet,
  },
  [ScreenNames.SimpleOnboarding_4_Allergens]: {
    screenName: ScreenNames.SimpleOnboarding_4_Allergens,
    nextScreen: ScreenNames.SimpleOnboarding_5_MealTimes,
    previousScreen: ScreenNames.SimpleOnboarding_3b_DietGoals,
  },
  [ScreenNames.SimpleOnboarding_5_MealTimes]: {
    screenName: ScreenNames.SimpleOnboarding_5_MealTimes,
    nextScreen: ScreenNames.PostOnboardingLoadingScreen,
    previousScreen: ScreenNames.SimpleOnboarding_4_Allergens,
  },
};

export const getNextScreen = (currentScreen: ScreenNames): ScreenNames | null => {
  const flowStep = SIMPLE_ONBOARDING_FLOW[currentScreen];
  return flowStep?.nextScreen || null;
};

export const getPreviousScreen = (currentScreen: ScreenNames): ScreenNames | null => {
  const flowStep = SIMPLE_ONBOARDING_FLOW[currentScreen];
  return flowStep?.previousScreen || null;
};
